<template>
  <!-- 옵션 :: https://github.com/mengxiong10/vue2-datepicker -->
  <date-picker
    class="imd-date-picker"
    input-class="w_inputno"
    type='date'
    format="YYYY-MM-DD"
    v-bind="$attrs"
    :placeholder=placeholder
    :value=value
    :lang=lang
    :clearable=false

    @input="changeDate"
    @selected="changeDate"
    >
  </date-picker>
</template>

<style>
/* div.imd-date-picker { display: inline-block; } */
div.imd-date-picker table.mx-panel-date > thead > tr > th,
div.imd-date-picker table.mx-panel-date > tbody > tr > td { width: 32px !important; text-align: center; padding: 0; }
div.imd-date-picker span.mx-input-append { height: 30px; margin-top:2px; ;cursor: pointer;}

.mx-datepicker.imd-date-picker { width:110px;}

@media screen and (max-width:640px){
  div.imd-date-picker span.mx-input-append {right:-4px; }
  .mx-datepicker.imd-date-picker { width:94px;}
  div.imd-date-picker .mx-input-wrapper { width:94px; }
  div.imd-date-picker .mx-input-wrapper input { width:94px !important; margin-right:0; box-sizing: border-box; padding:7px 0 7px 2px;}
}

</style>

<script>

// https://github.com/charliekassel/vuejs-datepicker

import DatePicker from 'vue2-datepicker'

export default {
  inheritAttrs: false,
  props: ['value','placeholder'],
  components: { DatePicker },
  data () {
    return {
      lang: {
        days: ['일', '월', '화', '수', '목', '금', '토'],
        months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        pickers: ['다음 7일', '다음 30일', '이전 7일', '다음 30일'],
        placeholder: {
          date: '날짜 선택',
          dateRange: '날짜 범위 선택'
        }
      },
    }
  },
  methods: {
    changeDate(v) {
      const emitValue = v ? this.$moment(v).format('YYYY-MM-DD') : ''
      this.$emit('input', emitValue)
    }
  },
}

</script>
